module.exports = __webpack_public_path__ + "resources/img/demo.369150c6.png";